import joi from "joi";
import { DESCRIPTION_JOI_VALIDATOR_MESSAGES, DESCRIPTION_VALIDATOR, EMAIL_JOI_VALIDATOR_MESSAGES, LINKS_JOI_VALIDATOR_MESSAGES, PROFILE_NAME_JOI_VALIDATOR_MESSAGES, PROFILE_NAME_VALIDATOR, USERNAME_VALIDATOR } from "../../validation.js";
const PASSWORD_VALIDATOR_REGEXP = {
    minLength: 8,
    maxLength: 100,
    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
    message: 'Password must contain at least 8 characters, one uppercase letter, one lowercase letter, one number and one special character'
};
const nameValidation = joi.string().pattern(PROFILE_NAME_VALIDATOR.pattern.value).min(PROFILE_NAME_VALIDATOR.minLength.value).max(PROFILE_NAME_VALIDATOR.maxLength.value).messages(PROFILE_NAME_JOI_VALIDATOR_MESSAGES).required();
const userPortraitValidation = joi.string().optional();
const descriptionValidation = joi.string().optional().max(DESCRIPTION_VALIDATOR.maxLength.value).pattern(DESCRIPTION_VALIDATOR.pattern.value).messages(DESCRIPTION_JOI_VALIDATOR_MESSAGES).allow(null, '');
const userNameValidation = joi.string().optional().max(USERNAME_VALIDATOR.maxLength.value).pattern(USERNAME_VALIDATOR.pattern.value).messages(PROFILE_NAME_JOI_VALIDATOR_MESSAGES).allow(null, '');
const socialAccountsValidation = joi.array().items(joi.object({
    link: joi.string().required(),
    label: joi.string().required()
})).optional();
const socialAccountsFormValidation = joi.array().items(joi.object({
    link: joi.string().uri().messages(LINKS_JOI_VALIDATOR_MESSAGES).optional().allow(null, ''),
    label: joi.string().uri().messages(LINKS_JOI_VALIDATOR_MESSAGES).optional().allow(null, '')
})).optional();
const privacyOptionsValidation = joi.object({
    isPrivate: joi.boolean().required()
}).optional();
const locationOptionsValidation = joi.object({
    location: joi.string().required(),
    locationVisible: joi.boolean().required()
}).optional();
const emailValidation = joi.string().email({
    tlds: {
        allow: false
    }
}).messages(EMAIL_JOI_VALIDATOR_MESSAGES).required();
const baseSchema = joi.object({
    name: nameValidation,
    username: userNameValidation,
    description: descriptionValidation,
    userPortrait: joi.string().optional().allow(null, ''),
    socialAccounts: socialAccountsValidation,
    privacyOptions: privacyOptionsValidation,
    locationOptions: locationOptionsValidation
});
export { PASSWORD_VALIDATOR_REGEXP, baseSchema, descriptionValidation, emailValidation, locationOptionsValidation, nameValidation, privacyOptionsValidation, socialAccountsFormValidation, socialAccountsValidation, userNameValidation, userPortraitValidation };
